import script from "./AutomationArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomationArea.vue?vue&type=script&setup=true&lang=ts"

import "./AutomationArea.vue?vue&type=style&index=0&id=7b2c3606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2c3606"]])

export default __exports__